import { type WrappedInsightCommunityReviewsAttributes } from "@clipboard-health/contract-backend-main";
import { Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";

import starsIcon from "../../assets/stars-wrapped.png";

interface CommunityReviewsContentProps {
  attributes: WrappedInsightCommunityReviewsAttributes;
}

export function CommunityReviewsContent(props: CommunityReviewsContentProps) {
  const { attributes } = props;

  return (
    <Stack flex={1} overflow="hidden">
      {/* Text section */}
      <Stack spacing={8} paddingX={8} paddingTop={12} sx={{ zIndex: 1 }}>
        <Text variant="body1" color="white">
          You weren&apos;t just showing up for shifts.{"\n"}You built our community by sharing
          reviews.
        </Text>

        <Stack spacing={1}>
          <Text variant="body1" color="white">
            You left
          </Text>
          <Stack direction="row" alignItems="baseline" spacing={1}>
            <Text variant="h1" color="white" sx={{ fontSize: "5rem", lineHeight: 1 }}>
              {attributes.numberOfReviews}
            </Text>
            <Text variant="body1" color="white" sx={{ fontSize: "1.25rem" }}>
              reviews
            </Text>
          </Stack>
        </Stack>
      </Stack>

      <Box
        component="img"
        src={starsIcon}
        alt="Stars"
        sx={{
          position: "absolute",
          bottom: 0,
          right: 0,
          width: "400px",
          height: "400px",
          maxWidth: "none",
          maxHeight: "none",
          objectFit: "contain",
          display: "block",
          zIndex: 0,
        }}
      />
    </Stack>
  );
}
